// src/components/AIFloater.jsx

import { useState, useRef, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styles from "./AIFloater.module.css";
import { useLocation } from "react-router-dom";
export default function AIFloater() {
  const location = useLocation();

  const [open, setOpen] = useState(false);

  const [input, setInput] = useState("");

  const [loading, setLoading] = useState(false);

  const [messages, setMessages] = useState([]);

  const [limitReached, setLimitReached] = useState(false);

  const [historyLoaded, setHistoryLoaded] = useState(false);
  const [remainingPrompts, setRemainingPrompts] = useState(null);
const [dailyLimit, setDailyLimit] = useState(5);
const [historyPage, setHistoryPage] = useState(1);
const [hasMoreHistory, setHasMoreHistory] = useState(false);
const [historyLoading, setHistoryLoading] = useState(false);
  const messagesEndRef = useRef(null);

  // auto scroll to latest message
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [messages]);

  useEffect(() => {
    if (!open || historyLoaded) return;

    loadHistory();
  }, [open]);

  async function loadHistory(page = 1) {
  try {
    setHistoryLoading(true);

    const token = localStorage.getItem("authToken");

    const response = await fetch(
      `https://backend.nessefy.com/api/business-chatbot/history?page=${page}&pageSize=30`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();

    const chats = data.chats?.$values || data.chats || [];

    if (typeof data.remainingPrompts === "number") {
      setRemainingPrompts(data.remainingPrompts);
      setLimitReached(data.remainingPrompts === 0);
    }

    if (typeof data.dailyLimit === "number") {
      setDailyLimit(data.dailyLimit);
    }

    setHasMoreHistory(Boolean(data.hasMore));
    setHistoryPage(data.page || page);

    const formatted = [];

    chats.forEach((chat) => {
      formatted.push({
        sender: "user",
        text: chat.userMessage,
      });

      formatted.push({
        sender: "bot",
        text: chat.aiResponse,
      });
    });

    if (page === 1) {
      if (formatted.length === 0) {
        setMessages([
          {
            sender: "bot",
            text: "Hi — I'm Nex.\n\nI can help with:\n• Startup ideas\n• Growth strategy\n• Pricing\n• Fundraising\n• Marketing\n\nWhat's your biggest challenge today?",
          },
        ]);
      } else {
        setMessages(formatted);
      }

      setHistoryLoaded(true);
    } else {
      setMessages((prev) => [...formatted, ...prev]);
    }
  } catch (err) {
    console.log(err);

    if (page === 1) {
      setMessages([
        {
          sender: "bot",
          text: "Unable to load previous chats.",
        },
      ]);
    }
  } finally {
    setHistoryLoading(false);
  }
}

function loadOlderChats() {
  if (historyLoading || !hasMoreHistory) return;

  loadHistory(historyPage + 1);
}

  const hiddenRoutes = [
    "/login",
    "/register",
    "/forgot-password",
    "/reset-password",
    "/messages",
    "/user-details"
  ];

  // hide on exact home OR child routes
  const shouldHide =
    location.pathname === "/" ||
    hiddenRoutes.some((route) => location.pathname.startsWith(route));

  if (shouldHide) {
    return null;
  }

  async function sendMessage(customMessage = null) {
    if (loading || limitReached) return;

    const finalMessage =
      typeof customMessage === "string" ? customMessage : input;

    if (!finalMessage || !finalMessage.trim()) return;

    const token = localStorage.getItem("authToken");

    const userMessage = {
      sender: "user",
      text: finalMessage,
    };

    setMessages((prev) => [...prev, userMessage]);

    setInput("");

    setLoading(true);

    try {
      const response = await fetch(
        "https://backend.nessefy.com/api/business-chatbot/ask",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",

            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify({
            message: finalMessage,
          }),
        },
      );

      const data = await response.json();

      const reply = data.reply || "Something went wrong";

      if (typeof data.remainingPrompts === "number") {
  setRemainingPrompts(data.remainingPrompts);
}

if (typeof data.dailyLimit === "number") {
  setDailyLimit(data.dailyLimit);
}

if (data.remainingPrompts === 0) {
  setLimitReached(true);
}

      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          text: reply,
        },
      ]);
    } catch {
      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          text: "Unable to connect to FounderAI.",
        },
      ]);
    } finally {
      setLoading(false);
    }
  }

  function setPrompt(text) {
    sendMessage(text);
  }

  return (
    <>
      {/* floating button */}
      <button className={styles.floatingBtn} onClick={() => setOpen(!open)}>
        <span className={styles.aiIcon}>◈</span>

        <span className={styles.betaDot}>BETA</span>
      </button>

      {open && (
        <div className={styles.chatBox}>
          {/* HEADER */}
          <div className={styles.aiheader}>
            <div className={styles.botArea}>
              <div className={styles.botAvatar}>◈</div>

              <div>
                <div className={styles.title}>
                  <span className={styles.nBlue}>NEX</span>
                </div>

                <div className={styles.subtitle}>
                  AI Cofounder
                  <span className={styles.beta}>BETA</span>
                </div>
                <div className={styles.promptSection}>
  <div className={styles.promptBadge}>
    <span className={styles.promptEmoji}>⚡</span>

    <span className={styles.promptValue}>
      {remainingPrompts}
    </span>

    <span className={styles.promptLabel}>
      AI Credits Remaining
    </span>
  </div>

  <div className={styles.promptProgress}>
    <div
      className={styles.promptProgressFill}
      style={{
        width: `${
          (((dailyLimit - (remainingPrompts ?? dailyLimit)) /
            dailyLimit) *
            100)
        }%`,
      }}
    />
  </div>
</div>
              </div>
            </div>

            <button className={styles.closeBtn} onClick={() => setOpen(false)}>
              ✕
            </button>
          </div>

          {/* MESSAGES */}
          <div className={styles.messages}>
            {hasMoreHistory && (
  <button
    className={styles.loadOlderBtn}
    disabled={historyLoading}
    onClick={loadOlderChats}
  >
    {historyLoading ? "Loading..." : "Load older chats"}
  </button>
)}
            {messages.map((msg, index) => (
              <div
                key={index}
                className={
                  msg.sender === "bot" ? styles.botMsg : styles.userMsg
                }
              >
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {msg.text}
                </ReactMarkdown>
              </div>
            ))}

            {/* typing loader */}
           {loading && !historyLoading && (
              <div className={styles.botMsg}>
                <div className={styles.typing}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            )}

            <div ref={messagesEndRef}></div>
          </div>

          {/* QUICK PROMPTS */}
          <div className={styles.prompts}>
            <button
             disabled={loading || historyLoading || limitReached}
              onClick={() => setPrompt("Give me a startup idea")}
            >
              Startup idea
            </button>

            <button
              disabled={loading || historyLoading || limitReached}
              onClick={() => setPrompt("Create a growth strategy")}
            >
              Growth plan
            </button>

            <button
              disabled={loading || historyLoading || limitReached}
              onClick={() => setPrompt("How should I market my startup?")}
            >
              Marketing
            </button>
          </div>

          {/* INPUT */}
          <div className={styles.inputArea}>
            <input
              disabled={loading || limitReached}
              onChange={(e) => setInput(e.target.value)}
              value={input}
              placeholder={
  limitReached
    ? "Daily limit reached"
    : "Brainstorm with Nex..."
}
            />

            <button
              disabled={loading || limitReached}
              onClick={() => sendMessage()}
            >
              ➤
            </button>
          </div>
        </div>
      )}
    </>
  );
}
